import styled from "styled-components/macro";

export const FeedbackPromptActions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;

export const FeedbackPromptActionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
`;
